import moment from "moment";
import React from "react";
import classNames from "classnames";
import styles from "../../../../../../styles/Campaigns/CampaignLogs.module.scss";
import InfoBlock from "../../../../../common/InfoBlock";
import { LogRenderContext } from "../LogRenderer";

const CampaignApproved = () => {
  const { log } = React.useContext(LogRenderContext);
  const { campaign, statusChangeRequest } = log.changedFields;
  const campaignName = log.dataSnapshot.campaign.name;
  return (
    <div className={styles.tabContainer}>
      <div className={styles.badgeContainer}>
        <div className={styles.campaignName}>{campaignName}</div>
        <div className={classNames(styles.badge, styles.badgeSuccess)}>
          <div>Approved</div>
        </div>
      </div>
      <InfoBlock
        header="Approval Details"
        className={styles.changeTracking}
        config={[
          {
            title: "Approved On",
            size: {
              sm: 6,
              xs: 6,
            },
            value: statusChangeRequest?.fromDate
              ? moment(statusChangeRequest.fromDate).format("MMM DD, YYYY, h:mm A")
              : undefined,
          },
          {
            title: "Approved By",
            value: campaign?.updatedBy.firstName
              ? `${campaign.updatedBy.firstName} ${campaign.updatedBy.lastName}`
              : "",
            size: {
              sm: 6,
              xs: 6,
            },
          },
          {
            title: "Comments",
            value: statusChangeRequest?.comments,
            size: {
              sm: 6,
              xs: 6,
            },
          },
        ]}
      />
    </div>
  );
};

export default CampaignApproved;
